export default __webpack_public_path__ + "static/media/cart_logo.1e29edbc.png";